import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {Navbar, Nav} from 'react-bootstrap';
import '../../containers/App.css';
import env from "react-dotenv";
import Modal from 'react-modal';
import MobileStoreButton from 'react-mobile-store-button';
import { setSecureItem } from '../../utils/encryption';

let URL = `${env.API_URL}/signin`

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    maxWidth              : '90%',
    maxHeight             : '90vh',
    overflow              : 'auto'
  }
};

Modal.setAppElement('#root')

class Signin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      setIsOpen: false,
      signInEmail: '',
      signInPassword: '',
      serverResponse: '',
      isLoading: false
    }
  }

  onEmailChange = (event) => {
    this.setState({signInEmail: event.target.value})
  }

  onPasswordChange = (event) => {
    this.setState({signInPassword: event.target.value})
  }

  onSubmitSignIn = () => {
  if (!this.state.signInEmail || !this.state.signInPassword) {
    this.setState({
      modalIsOpen: true,
      serverResponse: 'Please enter both email and password.'
    });
    return;
  }

  this.setState({ isLoading: true });

  fetch(URL, {
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    credentials: 'include',
    body: JSON.stringify({
      email: this.state.signInEmail,
      password: this.state.signInPassword
    })
  })
    .then(response => {
      if (response.status === 401 || response.status === 400) {
        return response.json().then(data => {
          throw new Error(data.error || data || 'Invalid credentials');
        });
      }
      return response.json();
    })
    .then(user => {
      this.setState({ isLoading: false });

      if (user.id) {
        console.log('✅ Login successful - session created');
        
        // ✅ user is already safe - just save it directly
        try {
          const stateToSave = {
            isSignedIn: true,
            user: user,  // Already has: id, first_name, last_name, email, image_key, rating, etc.
            route: 'home',
            blockedUsers: [],
            blockedDimes: [],
            timestamp: Date.now()
          };
          
          const success = setSecureItem('p10-app-state', stateToSave);
          
          if (success) {
            console.log('✅ User data encrypted and stored');
          }
        } catch (error) {
          console.error('❌ Error saving data:', error);
        }

        if (this.props.loadUser) {
          this.props.loadUser(user);
        }


        
    setTimeout(() => {
          if (this.props.onRouteChange) {
            this.props.onRouteChange('home');
          } else if (this.props.history) {
            this.props.history.push('/home');
          } else {
            window.location.href = '/home';
          }
        }, 100);  // ✅ Small delay ensures cookie is set
      
      } else {
        this.setState({
          modalIsOpen: true,
          serverResponse: 'Sign in failed.'
        });
      }
    })
    .catch(error => {
      console.error('❌ Sign in error:', error);
      this.setState({
        isLoading: false,
        modalIsOpen: true,
        serverResponse: error.message || 'Failed to sign in.'
      });
    });
}

  // Handle Enter key press
  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.onSubmitSignIn();
    }
  }

  render() {
    const { onRouteChange } = this.props;
    const { isLoading } = this.state;
    const iOSUrl = 'https://apps.apple.com/us/app/p10/id1586057562';
    
    return (
      <>
        {/* Main Content */}
        <div 
          className="main-content-wrapper"
          style={{ 
            display: 'flex', 
            flexDirection: 'column',
            maxWidth: '1200px', 
            margin: '0 auto', 
            padding: '20px', 
            gap: '20px',
            width: '100%',
            boxSizing: 'border-box',
            paddingBottom: '80px' // Add padding for fixed navbar
          }}
        >
          
          {/* Left Side - Sign In Form */}
          <article 
            className="br3 ba b--black-10 mv4 shadow-5" 
            style={{ 
              flex: 1,
              minWidth: 0,
              maxWidth: '100%'
            }}
          >
            <main className="pa4 black-80">
              <div className="measure" style={{ maxWidth: '100%' }}>
                <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                  <img 
                    src="/images/p10.jpg" 
                    alt="P10 Logo" 
                    className="br3 mb3" 
                    style={{ width: 80, height: 80 }}
                  />
                  <div className="f1 fw6 ph0 mh0 b mb3" style={{ fontSize: 'clamp(1.5rem, 5vw, 3rem)' }}>
                    Log in to p10
                  </div>

                  <div className="mv3">
                    <label className="db fw6 lh-copy f6" htmlFor="email-address">Email</label>
                    <input
                      className="pa2 input-reset ba bg-transparent hover-bg-black hover-black"
                      style={{ width: '100%', maxWidth: '100%' }}
                      type="email"
                      name="email-address"
                      id="email-address"
                      autoComplete="email"
                      onChange={this.onEmailChange}
                      onKeyPress={this.handleKeyPress}
                      disabled={isLoading}
                    />
                  </div>
                  <div className="mv3">
                    <label className="db fw6 lh-copy f6" htmlFor="password">Password</label>
                    <input
                      className="pa2 input-reset ba bg-transparent hover-bg-black hover-black"
                      style={{ width: '100%', maxWidth: '100%' }}
                      type="password"
                      name="password"
                      id="password"
                      autoComplete="current-password"
                      onChange={this.onPasswordChange}
                      onKeyPress={this.handleKeyPress}
                      disabled={isLoading}
                    />
                  </div>
                </fieldset>
                <div className="">
                  <input
                    onClick={this.onSubmitSignIn}
                    className="f6 link dim br3 ph3 pv2 mb2 dib white bg-dark-green pointer"
                    type="submit"
                    value={isLoading ? "Signing in..." : "Log in"}
                    disabled={isLoading}
                    style={{
                      opacity: isLoading ? 0.6 : 1,
                      cursor: isLoading ? 'not-allowed' : 'pointer'
                    }}
                  />
                </div>
                <div className="f6 fw6 ph0 mh0 mb3">
                  By continuing, you agree to p10's Conditions of Use and Privacy Notice.
                </div>
                <div className="lh-copy mt3">
                  <Link to={'/forgotpassword'} className='f6 link dim blue underline pointer'>
                    Forgot password?
                  </Link>
                </div>
                <div className="lh-copy mt3">
                  <span className="f6">Don't have an account?</span>
                  {onRouteChange ? (
                    <span 
                      onClick={() => onRouteChange('register')} 
                      className="f6 link dim blue pointer ml2"
                    >
                      Sign Up
                    </span>
                  ) : (
                    <Link to="/register" className="f6 link dim blue pointer ml2">
                      Sign Up
                    </Link>
                  )}
                </div>
                <div className="mt3">
                  <MobileStoreButton
                    store="ios"
                    url={iOSUrl}
                    linkProps={{ title: 'iOS Store Button' }}
                  />
                </div>
              </div>
              <Modal 
                style={customStyles} 
                isOpen={this.state.modalIsOpen} 
                onRequestClose={() => this.setState({modalIsOpen: false})}
              >
                <h2>Sign in status</h2>
                <p>{this.state.serverResponse}</p>
                <div>
                  <button 
                    onClick={() => this.setState({modalIsOpen: false})}
                    className="f6 link dim br3 ph3 pv2 mb2 dib white bg-dark-blue pointer"
                  >
                    Close
                  </button>
                </div>
              </Modal>
            </main>
          </article>

          {/* Right Side - How to Use Video */}
          <aside 
            className="br3 ba b--black-10 mv4 shadow-5 pa4 video-section" 
            style={{ 
              flex: 1,
              backgroundColor: '#f9f9f9',
              minWidth: 0
            }}
          >
            <h2 className="f2 fw6 mb3">How to Use p10 App</h2>
            
            <div className="mt3">
              <video 
                controls 
                width="100%" 
                style={{ borderRadius: '8px', maxWidth: '100%' }}
                poster="/images/video-thumbnail.jpg"
              >
                <source src="/videos/p10-tutorial.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            <div className="mt4 pa3 bg-white br2 ba b--light-gray">
              <p className="ma0 lh-copy f6">
                <strong>Watch the tutorial above</strong> to learn how to get started with p10 app. 
                The video covers installation, account setup, and key features.
              </p>
            </div>
          </aside>
        </div>

        {/* Bottom Navbar */}
        <Navbar fixed="bottom" style={{ 
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 -2px 20px rgba(0,0,0,0.1)',
          padding: '1rem'
        }}>
          <Nav style={{ 
            width: '100%', 
            display: 'flex', 
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: '0.5rem'
          }}>
            <span className="f6 gray" style={{ marginRight: '1rem' }}>p10rating © 2026</span>
            <Link to="/privacypolicy" className="f6 link dim blue pointer">Privacy</Link>
            <Link to="/disclaimer" className="f6 link dim blue pointer">Disclaimer</Link>
            <Link to="/terms" className="f6 link dim blue pointer">Terms</Link>
            <Link to="/about" className="f6 link dim blue pointer">About</Link>
            <Link to="/support" className="f6 link dim blue pointer">Contact</Link>
          </Nav>
        </Navbar>

        {/* Responsive Styles */}
        <style jsx>{`
          /* Desktop: side-by-side layout */
          @media (min-width: 768px) {
            .main-content-wrapper {
              flex-direction: row !important;
            }
          }

          /* Mobile: stacked layout (default) */
          @media (max-width: 767px) {
            .mv4 {
              margin-top: 1rem;
              margin-bottom: 1rem;
            }
            
            .pa4 {
              padding: 1.5rem;
            }
            
            .video-section h2 {
              font-size: 1.5rem;
            }
          }

          @media (max-width: 480px) {
            .pa4 {
              padding: 1rem;
            }
            
            footer .f6 {
              font-size: 0.75rem;
            }
            
            .video-section h2 {
              font-size: 1.25rem;
            }
          }
        `}</style>
      </>
    );
  }
}

export default withRouter(Signin);